"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledWarningBanner = exports.StyledButtonGroup = exports.StyledSelect = exports.ReviewReasonContent = exports.SelectReasonContent = exports.RescheduleReasonContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const banner_1 = __importDefault(require("@kyruus/banner"));
const simple_select_1 = require("@kyruus/simple-select");
const ui_theme_1 = require("@kyruus/ui-theme");
exports.RescheduleReasonContainer = styled_1.default.div `
  display: flex;
  gap: ${(_a) => {
    var { isDesktop } = _a, rest = __rest(_a, ["isDesktop"]);
    return isDesktop
        ? (0, ui_theme_1.fromTheme)('spacing_xxlarge')(rest)
        : (0, ui_theme_1.fromTheme)('spacing_xlarge')(rest);
}};
  flex-direction: column;
  width: 100%;
`;
exports.SelectReasonContent = styled_1.default.div `
  display: flex;
  span {
    font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
    margin: 0;
    color: ${(0, ui_theme_1.fromTheme)('color_text')};
    font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_5')};
  }
  label {
    font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
    padding: 0;
    padding-bottom: ${(0, ui_theme_1.fromTheme)('spacing_small')};
    // overriding default styles
    text-indent: 0;
    font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  }
  flex-direction: column;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_large')};
`;
exports.ReviewReasonContent = styled_1.default.div `
  display: flex;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_5')};
  p,
  span {
    font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
    margin: 0;
    color: ${(0, ui_theme_1.fromTheme)('color_text')};
    font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_5')};
  }
  flex-direction: column;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_large')};
`;
exports.StyledSelect = (0, styled_1.default)(simple_select_1.SingleSelect) `
  max-width: 28rem;
`;
exports.StyledButtonGroup = styled_1.default.div `
  display: flex;
  flex-direction: ${(props) => (props.isDesktop ? 'row' : 'column')};
  flex-basis: ${(props) => (props.isDesktop ? 'auto' : '100%')};
  gap: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  margin: ${(_a) => {
    var { isDesktop } = _a, rest = __rest(_a, ["isDesktop"]);
    return isDesktop ? 'unset' : `${(0, ui_theme_1.fromTheme)('spacing_medium')(rest)} 0 0 0`;
}};
`;
exports.StyledWarningBanner = (0, styled_1.default)(banner_1.default) `
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_small')};
`;
//# sourceMappingURL=styles.js.map